import _ from "lodash";
import Vue from "vue";
import { Message } from "element-ui";
import store from "@/store";

Vue.component(Message.name, Message);

/**
 * Helper del mes
 * @param {Number} MonthCriteria Numero del mes
 * @return {String}
 */
export const GetMonthInLetterBeginingOnZero = (MonthCriteria = Number) => {
  var month = new Array();
  month[0] = "January";
  month[1] = "February";
  month[2] = "March";
  month[3] = "April";
  month[4] = "May";
  month[5] = "June";
  month[6] = "July";
  month[7] = "August";
  month[8] = "September";
  month[9] = "October";
  month[10] = "November";
  month[11] = "December";
  return month[MonthCriteria];
};

/**
 * sessionStorage
 * @param {*} key
 * @param {*} value
 */
export const session = function (key, value) {
  if (value === void 0) {
    let lsVal = sessionStorage.getItem(key);
    if (lsVal && lsVal.indexOf("autostringify-") === 0) {
      return JSON.parse(lsVal.split("autostringify-")[1]);
    } else {
      return lsVal;
    }
  } else {
    if (typeof value === "object" || Array.isArray(value)) {
      value = "autostringify-" + JSON.stringify(value);
    }
    return sessionStorage.setItem(key, value);
  }
};

/**
 * manejo de errores ajax
 * @param {*} error
 */
export const catchError = function (error) {
  if (error.response) {
    switch (error.response.status) {
      case 400:
        console.error(error.response);
        Vue.prototype.$message({
          message:
            error.response.data.Message || "Solicitar excepción de parámetro",
          type: "error"
        });
        break;
      case 401:
        console.error(error.response);
        Vue.prototype.$message({
          message:
            error.response.data.Message ||
            "¡La contraseña es incorrecta o la cuenta no existe!",
          type: "warning",
          onClose: function () {
            return new Promise((resolve) => {
              resolve(store.dispatch("auth/logout"));
            });
          }
        });
        break;
      case 403:
        console.error(error.response);
        Vue.prototype.$message({
          message:
            error.response.data.Message ||
            "Sin acceso, comuníquese con el administrador de la empresa.",
          type: "warning"
        });
        break;
      case 404:
        console.error(error.response);
        Vue.prototype.$message({
          message: error.response.data.Message || "Registro no encontrado.",
          type: "info"
        });
        break;
      case 500:
        console.error(error.response);
        if (process.env.NODE_ENV !== "development") {
          Vue.prototype.$message({
            message: "Error critico, por favor notifcar a TI",
            type: "error"
          });
        }
        break;
      default:
        console.error(error.response);
        if (process.env.NODE_ENV !== "development") {
          Vue.prototype.$message({
            message:
              error.response.data.Message ||
              "El servidor es anormal, póngase en contacto con soporte técnico",
            type: "error"
          });
        }
        break;
    }
  }
  return Promise.reject(error);
};

/**
 * Formatear fechas
 * @param {Date} date fecha
 * @param {String} toFormat formato
 * @return {String} Fecha formateada
 */
export const formatDate = function (date, toFormat = "DD/MM/YYYY hh:mm:ss") {
  // date => "2020-06-25T10:54:07.28" or "2020-06-25T10:54:07.280"
  let format = "YYYY-MM-DDTHH:mm:ss.SS";
  if (date === "" || !date || date === undefined) return "";
  if (date.length === 23) {
    format = "YYYY-MM-DDTHH:mm:ss.SSS";
  }
  let mDate = Vue.prototype.$moment(date, format);

  if (mDate.isValid()) {
    return mDate.format(toFormat);
  }
  return "";
};

export const formatMoney = function (mount) {
  const formatter = new Intl.NumberFormat("es-DO", {
    stlye: "currency",
    currency: "DOP"
  });
  return formatter.format(mount.TotalAmountServices);
};

/**
 * Formatear numero de telefono
 * @param {String} phoneNumberString Numbero de telefono
 */
export const formatPhoneNumber = function (phoneNumberString) {
  if (!phoneNumberString) return "";

  let multi = phoneNumberString.split("/" || ";" || " ");

  const formatter = function (phone) {
    let cleaned = ("" + phone).replace(/\D/g, "");
    let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      let intlCode = match[1] ? "+1 " : "";
      return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
    }
    return phone;
  };

  if (multi.length > 1) {
    let phones = "";
    multi.forEach((p, i) => {
      if (i === 0) {
        phones = formatter(p);
      } else {
        phones = phones + " / " + formatter(p);
      }
    });
    return phones;
  } else if (multi.length === 1) {
    return formatter(phoneNumberString);
  }

  return "";
};

export const FormatCedula = function (cedNumber) {
  if (cedNumber.length === 11) {
    let cedula =
      cedNumber.slice(0, 3) +
      "-" +
      cedNumber.slice(3, 10) +
      "-" +
      cedNumber.slice(10);
    return cedula;
  } else {
    return cedNumber;
  }
};

/**
 * Paginar una lista de items.
 * @param {Array} items Lista a paginar
 * @param {Number} page Pagina a devolver
 * @param {Number} pageSize Items por pagina
 */
export const getPaginatedItems = function (
  items,
  page,
  pageSize /*, pageSizes*/
) {
  var pg = page || 1,
    pgSize = pageSize || 100,
    offset = (pg - 1) * pgSize,
    pagedItems = _.drop(items, offset).slice(0, pgSize);
  return {
    page: pg,
    pageSize: pgSize,
    // pageSizes: [10,50,100,500],
    total: items.length,
    total_pages: Math.ceil(items.length / pgSize),
    data: pagedItems
  };
};

/**
 * Deficado a dar formato a una lista para el-select.
 * @param {Array} list Items para ser formatea a lista aceptada por el-select
 * @param {Object} keys Objeto para indicar que clave del item seran usadas.
 */
export const formatArrayToElSelect = function (list, keys = {}) {
  let b = [];
  const keyRoot = {
    ...{ label: "Name", value: "Id", IsEnabled: "IsEnabled" },
    ...keys
  };

  for (let item of list) {
    const value = item[keyRoot.value];
    // TODO: Al crear una nueva solicitud se debe asignar un contacto,
    // donde el valor del contacto es ContactCode, si este valor es nulo
    // no debe ser seleccionable.
    if (!value) {
      continue;
    } else {
      b.push({
        label: item[keyRoot.label],
        value: value,
        IsEnabled: item[keyRoot.IsEnabled],
        ...item
      });
    }
  }

  return b;
};

export const sleep = function (ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const formatterMoney = function (number) {
  if (!number) return "";

  const formatter = new Intl.NumberFormat("es-DO", {
    stlye: "currency",
    currency: "DOP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  const f = formatter.format(number);
  return "$ " + f; // parseFloat(f).toFixed(2);
};

export const formatterMoneyWithCurrency = function (number, currency) {
  if (!number) return 0;

  const formatter = new Intl.NumberFormat("es-DO", {
    stlye: "currency",
    currency: "DOP",
    minimumFractionDigits: 2
  });

  const f = formatter.format(number).replace(/,/g, "").replace(".", ".");
  return `$${currency} ` + parseFloat(f).toLocaleString("en");
};

export const IsInRole = (rolename = "", roles = []) => {
  if (roles.length > 0) {
    let v = false;

    roles.forEach((rol) => {
      if (v === true) return;
      v = rol.Name.trim().toLowerCase() === rolename.trim().toLowerCase();
    });

    return v;
  } else {
    return false;
  }
};

export const IsInRoles = (rolesname = [], roles = []) => {
  try {
    if (roles.length > 0) {
      let v = false;

      roles.forEach((rol) => {
        if (v === true) return;
        v = rolesname
          .map((r) => r.trim().toLowerCase())
          .includes(rol.Name.trim().toLowerCase());
      });

      return v;
    } else {
      return false;
    }
  } catch (_) {
    return false;
  }
};

export const formatMonto = (value, absolute = false) => {
  if (absolute && value < 0) {
    value = value * -1;
  }
  let val = isNaN((value / 1).toFixed(2).replace(",", "."))
    ? 0.0
    : (value / 1).toFixed(2).replace(",", ".");

  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatMontoVendors = (value) => {
  let val = (value / 1).toFixed(2).replace(",", ".");
  if (val > 0) {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return "";
  }
};

export const formatQty = (value) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatMontoKPI = (value) => {
  let val = (value / 1).toFixed().replace(",", ".");
  return val.toString("%").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatMontoSales = (value) => {
  let val = (value / 1).toFixed().replace(",", ".");
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatMonto1 = (value) => {
  let val = (value / 1).toFixed(2).replace(",", ".");
  if (val < 70) {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return "";
  }
};

export const FormatPercentSalesKpi = (value) => {
  // if (value > 0) {
  return `${formatMontoKPI(value)} %`;
  // } else {
  //   return "";
  // }
};

export const FormatPercentSales = (value) => {
  // if (value > 0) {
  return `${formatMonto(value)}`;
  // } else {
  //   return "";
  // }
};

export const FormatStar = (value) => {
  if (value == 1) {
    return "★";
  }
  if (value == 2) {
    return "★★";
  }
  if (value == 3) {
    return "★★★";
  }
  if (value == 4) {
    return "★★★★";
  }
  if (value == 5) {
    return "★★★★★";
  } else {
    return "SIN CALIFICAR";
  }
};

export const getTagType = (value) => {
  if (value == 0) {
    return "danger";
  }
  return "info";
};

export function buildParams(paramsObject) {
  return Object.keys(paramsObject)
    .map((key) => {
      let resultValue = paramsObject[key];

      if (typeof paramsObject[key] === "object") {
        resultValue = JSON.stringify(paramsObject[key]);
      }

      return `${encodeURIComponent(key)}=${encodeURIComponent(resultValue)}`;
    })
    .join("&");
}

/**
 * Este metodo se volvio repetitivo en cada tabla del lado del cliente
 * por tanto este helper ayudar a evitar esta duplicidad de codigo.
 *
 * Este recibe un searh y sus items y realiza la busqueda pertinente en items
 * y devuelve lo encontrado.
 *
 * Esto es util en un computed.
 * @param {string} search Valor a buscar
 * @param {Array} items Lista de items a filtrar
 * @param {Function} toggleLoading Funcion para activar/desactivar un loading
 * @returns items encontrado
 */
export function filterItems(search, items, toggleLoading = null) {
  if (items.length <= 0) {
    return items;
  }

  if (toggleLoading != null) {
    toggleLoading();
  }
  const keys = Object.keys(items[0]);

  if (search.length > 0) {
    items = items.filter((data) => {
      for (let i = 0; i < keys.length; i++) {
        let value = data[keys[i]];
        const valueType = typeof value;

        if (["number", "boolean"].includes(valueType)) {
          value = value.toString();
        }

        if (
          valueType !== "object" &&
          value &&
          value.toLowerCase().includes(search.toLowerCase())
        ) {
          return data;
        }
      }
    });
  }
  if (toggleLoading != null) {
    toggleLoading();
  }
  return items;
}

export function formatNumber(value) {
  return Number(value).toLocaleString("en-US");
}
